export class Auth {
  private static instance: Auth;
  private baseUrl: string;
  private authTokenKey: string;

  private constructor(authTokenKey?: string) {
    this.authTokenKey = authTokenKey ?? "authToken";
    const API_URL = import.meta.env.N7AIT_API_URL;
    this.baseUrl = `${API_URL}/api-front`;
  }

  public static getInstance(): Auth {
    if (!Auth.instance) Auth.instance = new Auth();
    return Auth.instance;
  }

  public getAuthHeader(): { Authorization: string } {
    const token = this.token;
    if (!token) throw new Error("No authentication token found");
    return { Authorization: `Bearer ${token}` };
  }

  public get token(): string | null {
    return localStorage.getItem(this.authTokenKey) ?? null;
  }

  public set token(token: string) {
    localStorage.setItem(this.authTokenKey, token);
  }

  public removeAuthToken() {
    localStorage.removeItem(this.authTokenKey);
  }

  public apiUrl(elements: (string | number)[], queryParams?: Record<string, string | number>) {
    if (!queryParams) return `${this.baseUrl}/${elements.join("/")}/` as const;
    const params = new URLSearchParams(queryParams as Record<string, string>);
    return `${this.baseUrl}/${elements.map((e) => e.toString()).join("/")}/?${params.toString()}` as const;
  }
}
